<template>
  <v-row>
    <Member :site="$attrs.site_key" :is-edit="isEdit"></Member>
  </v-row>
</template>

<script>
import Member from '@/components/Member'
import api from '@/mixins/api'

export default {
  name: 'member_create',
  components: { Member },
  mixins: [api],
  computed: {
    isEdit() {
      return this.$route.name === 'members_edit'
    },
  },
}
</script>
